module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "back"
  }, [_c('div', {
    staticClass: "back__btn",
    on: {
      "click": function($event) {
        return _vm.$emit('back')
      }
    }
  }, [_c('h4', {
    staticClass: "back__title"
  }, [_vm._v("Назад")])]), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0db6a764","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/back/Back.vue
// module id = 4208d9e1759623aecc02
// module chunks = 89